export var FeatureFlags = {
    SHOW_LEARNER_SEARCH: process.env.NEXT_PUBLIC_LDY_1610_SHOW_LEARNER_SEARCH,
    SHOW_FILTER_LESSONS_BY_LEARNER_ID: process.env.NEXT_PUBLIC_LDY_1767_SHOW_FILTER_LESSONS_BY_LEARNER_ID,
    INTERCOM: process.env.NEXT_PUBLIC_INTERCOM,
    SHOW_BUDGET_PER_LESSON_TUTOR_REQUEST: process.env.NEXT_PUBLIC_DFY_649_SHOW_BUDGET_PER_LESSON_TUTOR_REQUEST,
    SHOW_LEARNER_FEEDBACK_TYPEFORM: process.env.NEXT_PUBLIC_SHOW_LEARNER_FEEDBACK_TYPEFORM,
    SHOW_TUTORING_CONTRACTS: process.env.NEXT_PUBLIC_TXP_342_SHOW_TUTORING_CONTRACTS,
    SET_PLATFORM_COOKIE: process.env.NEXT_PUBLIC_BCN_412_SET_PLATFORM_COOKIE,
    LEARNER_ONBOARDING: process.env.NEXT_PUBLIC_SHOW_LEARNER_ONBOARDING,
    LEARNER_ONBOARDING_V2: process.env.NEXT_PUBLIC_SHOW_LEARNER_ONBOARDING_V2,
    COOKIE_PLATFORM_REDIRECT: process.env.NEXT_PUBLIC_BCN_417_COOKIE_PLATFORM_REDIRECT,
    LDY_1554_LESSON_ATTENDANCE_TIMELINE: process.env.NEXT_PUBLIC_LDY_1554_LESSON_ATTENDANCE_TIMELINE,
    SHOW_BUY_EXTRA_LESSONS: process.env.NEXT_PUBLIC_BEE_531_SHOW_BUY_EXTRA_LESSONS,
    SHOW_TUTOR_SPC_SLOTS: process.env.NEXT_PUBLIC_TXP_400_SHOW_TUTOR_SPC_SLOTS,
    SPC_AVAILABILITY: process.env.NEXT_PUBLIC_BCN_445_SPC_AVAILABILITY,
    SPC_AVAILABILITY_FREE_CONSULTATION_STEP: process.env.NEXT_PUBLIC_BCN_445_SPC_AVAILABILITY_FREE_CONSULTATION_STEP,
    SHOW_LESSON_AVAILABILITY_SLOTS: process.env.NEXT_PUBLIC_DFY_855_SHOW_LESSON_AVAILABILITY_SLOTS,
    ALLOW_TUTOR_TO_OPT_OUT: process.env.NEXT_PUBLIC_TXP_447_ALLOW_TUTOR_TO_OPT_OUT,
    SHOW_LEARNER_SETTINGS_TAB: process.env.NEXT_PUBLIC_LEA_815_LEA_803_LEARNER_SETTINGS_TAB,
    SHOW_LEARNER_MESSAGES_PAGE: process.env.NEXT_PUBLIC_BEE_549_SHOW_LEARNER_MESSAGES_PAGE,
    BRIGHT_HORIZONS: process.env.NEXT_PUBLIC_ENABLE_BRIGHT_HORIZONS,
    SHOW_SUBSCRIPTIONS_REMOVE_LESSONS: process.env.NEXT_PUBLIC_BEE_686_SHOW_SUBSCRIPTIONS_REMOVE_LESSONS,
    SUBMIT_SNOWPLOW_FORM_CONTEXTS: process.env.NEXT_PUBLIC_BEE_659_SUBMIT_SNOWPLOW_FORM_CONTEXTS,
    TUTOR_MATCHES_SINGLE_COLUMN_LAYOUT: process.env.NEXT_PUBLIC_DFY_1138_TUTOR_MATCHES_SINGLE_COLUMN_LAYOUT,
    ENABLE_WEBTRENDS_OPTIMIZE: process.env.NEXT_PUBLIC_DFY_1166_ENABLE_WEBTRENDS_OPTIMIZE,
};
